<template>
  <!-- 关于我们——企业文化 -->

  <!-- pc端 -->
  <div v-if="isPCFlag">
    <!-- 第一部分顶部大图导航 -->
    <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

    <!-- 第二部分 -->
    <div class="about_part3">
      <div class="about_part3_main">
        <div class="about_part3_left">
          <div class="about_part3_left_mian vision_mian">
            <h1 ref="visionTitle" id="visionTitle">愿景</h1>
            <div ref="visionMain" id="visionMain" class="about_part3_left_info vision_info">
              <p style="margin-bottom:39.5px;">成长为物联网场景应用的领导者。</p>
              <p>万物理想致力于深耕物联网场景应用领域，从行业痛点出发，从应用场景出发，从客户价值出发，用创造力和行动实现物联网与传统行业的深度融合，为客户提供更有价值的物联网应用产品及解决方案，决心成长为物联网场景应用的领导者。</p>
            </div>
          </div>
        </div>
        <div class="about_part3_right vision_img" ref="visionImg" id="visionImg">
          <div class="shade" ref="shadeTranslatevisionImg" id="shadeTranslatevisionImg"></div>
          <img src="../../assets/imgs/about/vision_pic.jpg" ref="imgTranslatevisionImg" id="imgTranslatevisionImg">
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="about_part3 about_part3_bg">
      <div class="about_part3_main">
        <div class="about_part3_right vision_img" ref="part3Img" id="part3Img">
          <div class="shade" ref="shadeTranslateThree" id="shadeTranslateThree"></div>
          <img src="../../assets/imgs/about/mission_pic.jpg" ref="imgTranslateThree" id="imgTranslateThree">
        </div>
        <div class="about_part3_left">
          <div class="about_part3_left_mian vision_mian">
            <h1 ref="part3Title" id="part3Title">使命</h1>
            <div ref="mainfontThree" id="mainfontThree" class="about_part3_left_info vision_info">
              <p>成就员工、赋能客户、回馈社会，为国家数字化经济建设尽绵薄之力。</p>
              <p>员工是企业发展的基石，让每位员工都有对等的发展机会，让每位员工都有实现梦想的阶梯，让每位员工都有体面的工作、体面的生活，是万物理想矢志不渝坚守的初心。</p>
              <p>数字化转型是企业发展的跳板，以科技赋能推进传统行业数字化转型，助力传统企业高质量发展，用数字化的力量担起责任，为国家数字化经济建设贡献一份力量，是万物理想矢志不渝践行的使命。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第四部分 -->
    <div class="about_part3">
      <div class="about_part3_main">
        <div class="about_part3_left">
          <div class="about_part3_left_mian vision_mian">
            <h1 ref="valuesTitle" id="valuesTitle">核心价值观</h1>
            <div ref="valuesMainfont" id="valuesMainfont" class="about_part3_left_info vision_info">
              <h4>创造价值</h4>
              <p>精准洞察客户需求，聚焦客户数字化体验，以科技为客户创造价值。</p>
              <h4>共享丰盛</h4>
              <p>公司业务发展和战略规划信息在内部完全公开透明，与全体“万物理想人”共享企业发展的成果，实现生活品质的逐步提升。</p>
              <h4>持续创新</h4>
              <p>拥抱变化，迎接挑战，勇于创新，成就卓越。</p>
            </div>
          </div>
        </div>
        <div class="about_part3_right vision_img" ref="valuesImg" id="valuesImg">
          <div class="shade" ref="shadeTranslatevaluesImg" id="shadeTranslatevaluesImg"></div>
          <img src="../../assets/imgs/about/values_pic.jpg" ref="imgTranslatevaluesImg" id="imgTranslatevaluesImg">
        </div>
      </div>
    </div>

    <!-- 第五部分尾部公用组件 -->
    <bottomFooter></bottomFooter>
  </div>
  <!-- 移动端 -->
  <div v-else class="companyculture-mobile">
    <!-- 第一部分顶部大图导航 -->
    <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></mobileTopBigPic>
    <!-- 第二部分 -->
    <div class="mobile-about-part2">
      <div class="bg mobile-container"></div>
      <div class="title">
        愿景
      </div>
      <div class="info mobile-container">
        <p class="margin-bottom-167">成长为物联网场景应用的领导者。</p>
        <p class="padding-bottom-293">万物理想致力于深耕物联网场景应用领域，从行业痛点出发，从应用场景出发，从客户价值出发，用创造力和行动实现物联网与传统行业的深度融合，为客户提供更有价值的物联网应用产品及解决方案，决心成长为物联网场景应用的领导者。</p>
      </div>
    </div>
    <!-- 第三部分 -->
    <div class="mobile-about-part3 mobile-about-part3-bg">
      <div class="bg mobile-container"></div>
      <div class="title">
        使命
      </div>
      <div class="info mobile-container">
        <p class="margin-bottom-167">成就员工、赋能客户、回馈社会，为国家数字化经济建设尽绵薄之力。</p>
        <p class="margin-bottom-167">员工是企业发展的基石，让每位员工都有对等的发展机会，让每位员工都有实现梦想的阶梯，让每位员工都有体面的工作、体面的生活，是万物理想矢志不渝坚守的初心。</p>
        <p class="padding-bottom-293">数字化转型是企业发展的跳板，以科技赋能推进传统行业数字化转型，助力传统企业高质量发展，用数字化的力量担起责任，为国家数字化经济建设贡献一份力量，是万物理想矢志不渝践行的使命。</p>
      </div>
    </div>
    <!-- 第四部分 -->
    <div class="mobile-about-part4">
      <div class="bg"></div>
      <div class="title">
        核心价值观
      </div>
      <div class="info mobile-container">
        <div class="h4-title">创造价值</div>
        <p class="margin-bottom-167">精准洞察客户需求，聚焦客户数字化体验，以科技为客户创造价值。</p>
        <div class="h4-title">共享丰盛</div>
        <p class="margin-bottom-167">公司业务发展和战略规划信息在内部完全公开透明，与全体“万物理想人”共享企业发展的成果，实现生活品质的逐步提升。</p>
        <div class="h4-title">持续创新</div>
        <p class="padding-bottom-293">拥抱变化，迎接挑战，勇于创新，成就卓越。</p>
      </div>
    </div>
    <!-- 第五部分尾部公用组件 -->
    <mobileBottomFooter></mobileBottomFooter>
  </div>
</template>

<script>
import topBigPic from "@/components/global/topBigPic.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import bottomFooter from "@/components/global/bottomFooter.vue";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import animationUtils from "@/utils/animationUtils.js";
import { isPC } from "@/utils/tools.js";

export default {
  name: "companyculture",
  data() {
    return {
      isPCFlag: true,
      //顶部导航数据
      topBgImg: require("../../assets/imgs/about/whtop_bg.jpg"),
      mobileTopBgImg: require("../../assets/imgs/mbAbout/companyculture/whtop_bg.jpg"),
      bigTitle: {
        znTitle: "企业文化",
        enTitle: "OUR CULTURE",
      },
      menuLi: {
        sortOne: {
          title: "关于我们",
          children: [
            {
              name: "产品中心",
              active: false,
              url: "/comdedeauto",
            },
            {
              name: "解决方案",
              active: false,
              url: "/solutionadmi",
            },
            {
              name: "新闻动态",
              active: false,
              url: "/companyNews",
            },
            {
              name: "关于我们",
              active: true,
              url: "/companyprofile",
            },
            {
              name: "职等你来",
              active: false,
              url: "/jobmarket",
            },
          ],
        },

        sortTwo: {
          title: "企业文化",
          children: [
            {
              name: "公司简介",
              active: false,
              url: "/companyprofile",
            },
            {
              name: "企业文化",
              active: true,
              url: "/companyculture",
            },
            {
              name: "荣誉资质",
              active: false,
              url: "/honorqualification",
            },
            {
              name: "联系我们",
              active: false,
              url: "/contactus",
            },
          ],
        },
      },
    };
  },
  created() {
    this.isPCFlag = isPC();
  },
  mounted() {
    this.isPCFlag ? window.addEventListener("scroll", this.menu) : "";
  },
  beforeDestroy() {
    //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
    this.isPCFlag ? window.removeEventListener("scroll", this.menu) : "";
  },
  methods: {
    //滚动条监听
    menu() {
      /**
       * animations方法的第一个参数是需要动画的dom元素的高度，
       * 第二个参数是需要加动画的dom元素的样式列表数组，
       * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
       */
      //第二部分标题动画
      let visionTitleOffsetTop = this.$refs.visionTitle.offsetTop; //获取当前元素距离文档顶部的高度
      let visionTitle = this.$refs.visionTitle.classList;
      animationUtils.animations(
        visionTitleOffsetTop,
        visionTitle,
        "activeTitle"
      );
      //第二部分图的动画
      let shadeTranslatevisionImgOffsetTop =
        this.$refs.shadeTranslatevisionImg.offsetTop; //获取当前元素距离文档顶部的高度
      let shadeTranslatevisionImg =
        this.$refs.shadeTranslatevisionImg.classList; //遮罩样式数组
      let imgTranslatevisionImg = this.$refs.imgTranslatevisionImg.classList; //图片样式数组
      animationUtils.animations(
        shadeTranslatevisionImgOffsetTop,
        shadeTranslatevisionImg,
        "activeShade"
      );
      animationUtils.animations(
        shadeTranslatevisionImgOffsetTop,
        imgTranslatevisionImg,
        "activeImg"
      );

      //第二部分文字描述动画
      let visionMainOffsetTop = this.$refs.visionMain.offsetTop;
      let visionMainClassList = this.$refs.visionMain.classList;
      animationUtils.animations(
        visionMainOffsetTop,
        visionMainClassList,
        "activeTitle"
      );

      //第三部分标题动画
      let partThreeTitleOffsetTop = this.$refs.part3Title.offsetTop; //获取当前元素距离文档顶部的高度
      let partThreeTitle = this.$refs.part3Title.classList;
      //
      animationUtils.animations(
        partThreeTitleOffsetTop,
        partThreeTitle,
        "activeTitle"
      );

      //第三部分图的动画
      let partThreeImgOffsetTop = this.$refs.part3Img.offsetTop; //获取当前元素距离文档顶部的高度
      let shadeTranslateThree = this.$refs.shadeTranslateThree.classList; //遮罩样式数组
      let imgTranslateThree = this.$refs.imgTranslateThree.classList; //图片样式数组
      animationUtils.animations(
        partThreeImgOffsetTop,
        shadeTranslateThree,
        "activeShade"
      );
      animationUtils.animations(
        partThreeImgOffsetTop,
        imgTranslateThree,
        "activeImg"
      );

      //第三部分文字描述动画
      let mainfontThreeOffsetTop = this.$refs.mainfontThree.offsetTop;
      let mainfontThreeClassList = this.$refs.mainfontThree.classList;
      animationUtils.animations(
        mainfontThreeOffsetTop,
        mainfontThreeClassList,
        "activeTitle"
      );

      //第四部分标题动画
      let valuesTitleOffsetTop = this.$refs.valuesTitle.offsetTop; //获取当前元素距离文档顶部的高度
      let valuesTitle = this.$refs.valuesTitle.classList;
      //
      animationUtils.animations(
        valuesTitleOffsetTop,
        valuesTitle,
        "activeTitle"
      );

      //第四部分图的动画
      let shadeTranslatevaluesImgOffsetTop = this.$refs.valuesImg.offsetTop; //获取当前元素距离文档顶部的高度
      let shadeTranslatevaluesImg =
        this.$refs.shadeTranslatevaluesImg.classList; //遮罩样式数组
      let imgTranslatevaluesImg = this.$refs.imgTranslatevaluesImg.classList; //图片样式数组
      animationUtils.animations(
        shadeTranslatevaluesImgOffsetTop,
        shadeTranslatevaluesImg,
        "activeShade"
      );
      animationUtils.animations(
        shadeTranslatevaluesImgOffsetTop,
        imgTranslatevaluesImg,
        "activeImg"
      );

      //第四部分文字描述动画
      let valuesMainfontOffsetTop = this.$refs.valuesMainfont.offsetTop;
      let valuesMainfontClassList = this.$refs.valuesMainfont.classList;
      animationUtils.animations(
        valuesMainfontOffsetTop,
        valuesMainfontClassList,
        "activeTitle"
      );
    },
  },
  components: {
    topBigPic,
    mobileTopBigPic,
    bottomFooter,
    mobileBottomFooter,
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1020px) {
  .about_part3_left_info > p {
    margin-bottom: 12px;
  }
  #part3Title {
    margin-bottom: 18px;
  }
}

@media screen and (min-width: 1020px) and (max-width: 2000px) {
  .about_part3_left_info > p {
    margin-bottom: 20px;
  }
  #part3Title {
    margin-bottom: 30px;
  }
}

@media screen and (min-width: 2000px) {
  .about_part3_left_info > p {
    margin-bottom: 30px;
  }
  #part3Title {
    margin-bottom: 45px;
  }
}
.companyculture-mobile {
  width: 1920px;
  .marlr {
    margin: 0 71.11px;
  }
  .mobile-container {
    width: 1778px;
    margin: 0 auto;
  }
  .margin-bottom-167 {
    margin-bottom: 167px;
  }
  .padding-bottom-293 {
    padding-bottom: 293px;
  }
  .title {
    width: 1720px;
    height: 180px;
    line-height: 180px;
    font-size: 156px;
    font-weight: 600;
    margin: 206px 0 107px;
    margin-left: 71.11px;
    color: #000000;
  }
  .bg {
    width: 1778px;
    height: 1031px;
  }
  .info {
    font-size: 71px;
    font-weight: 400;
    color: #323333;
    line-height: 128px;
    text-align: justify;
  }
  .mobile-about-part2 {
    .bg {
      margin-top: 284px;
      background: url(../../assets/imgs/mbAbout/companyculture/vision_pic.jpg)
        no-repeat;
      background-size: cover;
    }
  }
  .mobile-about-part3-bg {
    padding-top: 284px;
    background: #f9f9f9;
  }
  .mobile-about-part3 {
    .bg {
      background: url(../../assets/imgs/mbAbout/companyculture/mission_pic.jpg)
        no-repeat;
      background-size: cover;
    }
  }
  .mobile-about-part4 {
    .bg {
      margin-top: 284px;
      background: url(../../assets/imgs/mbAbout/companyculture/values_pic.jpg)
        no-repeat;
      background-size: cover;
    }
    .info {
      .h4-title {
        font-size: 85px;
        font-weight: 600;
        color: #000000;
        margin-bottom: 60px;
      }
    }
  }
}
</style>